import { vscodeTheme } from '../../styles/theme';

interface AuthRequiredModalProps {
  isOpen: boolean;
  onRelogin: () => void;
}

export function AuthRequiredModal({ isOpen, onRelogin }: AuthRequiredModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: vscodeTheme.colors.sidebarBackground,
          border: `1px solid ${vscodeTheme.colors.border}`,
          borderRadius: '10px',
          padding: '24px',
          width: '360px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          color: vscodeTheme.colors.textPrimary,
        }}
      >
        <div style={{ fontSize: '16px', fontWeight: 600 }}>
          セッションが切れました
        </div>
        <div style={{ fontSize: '13px', color: vscodeTheme.colors.textSecondary }}>
          再ログインして続行してください。
        </div>
        <button
          type="button"
          onClick={onRelogin}
          style={{
            padding: '10px 14px',
            backgroundColor: vscodeTheme.colors.activeBackground,
            border: `1px solid ${vscodeTheme.colors.border}`,
            color: vscodeTheme.colors.textPrimary,
            cursor: 'pointer',
            fontSize: '13px',
            borderRadius: '6px',
            fontFamily: vscodeTheme.typography.fontFamily,
          }}
        >
          再ログイン
        </button>
      </div>
    </div>
  );
}
